var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',[_c('MainHeader',{staticClass:"main-header"}),_c('DrawingResult',{attrs:{"drawing-uuid":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }